import React, { useState } from "react";
import Form from "./Form";
import Results from "./Results";

const apiUrl = "/wp-json/pan/v1/faqs";

const FAQSearch = () => {
  const [query, setQuery] = useState("");
  const [manuallySubmitted, setManuallySubmitted] = useState(false);

  return (
    <div className="u-relative">
      <Form setQuery={setQuery} setManuallySubmitted={setManuallySubmitted} />
      {query && (
        <Results
          url={apiUrl}
          params={{ q: query }}
          manuallySubmitted={manuallySubmitted}
        />
      )}
    </div>
  );
};

export default FAQSearch;
